import {CrudModel} from '@ngx-ivengi/crud';

export class Charge extends CrudModel {

  public description: string;
  public count: string;
  public amount: string;

  public setDescription(description: string): Charge {
    if(typeof description === 'string') {
      this.description = description;
    }
    return this;
  }

  public setCount(count: string): Charge {
    if(typeof count === 'string') {
      this.count = count;
    }
    return this;
  }

  public setAmount(amount: string): Charge {
    if(typeof amount === 'string') {
      this.amount = amount;
    }
    return this;
  }
  public fromResponse(response: any): void {
    this
      .setId(response.id)
      .setDescription(response.description)
      .setCount((typeof(response.count) !== 'string') ? response.count.toString() : response.count)
      .setAmount((typeof(response.amount) !== 'string') ? response.amount.toString() : response.amount);

  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/charge/charge.model.ts